<template>
  <header id="page-topbar">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link tag="a" to="/" class="logo logo-dark">
            <span class="logo-sm">
              <!-- <img src="@/assets/images/logo.svg" alt height="22" /> -->
              <img
                src="@/assets/images/mascot-logo.png"
                alt
                style="max-height: 50px"
              />
            </span>
            <span class="logo-lg">
              <!-- <img src="@/assets/images/logo-dark.png" alt height="17" /> -->
              <img
                src="@/assets/images/mascot-logo.png"
                alt
                style="max-height: 50px"
              />
            </span>
          </router-link>

          <router-link tag="a" to="/" class="logo logo-light">
            <span class="logo-sm">
              <!-- <img src="@/assets/images/logo-light.svg" alt height="22" /> -->
              <img
                src="@/assets/images/mascot-logo.png"
                alt
                style="max-height: 50px"
              />
            </span>
            <span class="logo-lg">
              <!-- <img src="@/assets/images/logo-light.png" alt height="19" /> -->
              <img
                src="@/assets/images/mascot-logo.png"
                alt
                style="max-height: 50px"
              />
            </span>
          </router-link>
        </div>

        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <!-- App Search-->
        <form class="app-search d-none d-lg-block">
          <div class="position-relative">
            <input
              type="text"
              class="form-control"
              :placeholder="$t('navbar.search.text')"
            />
            <span class="bx bx-search-alt"></span>
          </div>
        </form>
      </div>

      <div class="d-flex">
        <b-dropdown
          class="d-inline-block d-lg-none ml-2"
          variant="black"
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          right
        >
          <template v-slot:button-content>
            <i class="mdi mdi-magnify"></i>
          </template>

          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search ..."
                  aria-label="Recipient's username"
                />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </b-dropdown>

     
        <div class="d-none d-lg-inline-block noti-icon mt-2">
          <b-button
            v-if="GET_APPLICATION_SELECTED.id"
            variant="light"
            @click="$bvModal.show('modal-scoped')"
          >
            <b-avatar :text="GET_APPLICATION_SELECTED.code" variant="info" />
            {{ GET_APPLICATION_SELECTED.name }}
          </b-button>
          <i v-else class="bx bx-customize"></i>
        </div>

        <div class="dropdown d-none d-lg-inline-block ml-1">
          <button
            type="button"
            class="btn header-item noti-icon"
            @click="initFullScreen"
          >
            <i class="bx bx-fullscreen"></i>
          </button>
        </div>

        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <img
              v-if="userOAuth && userOAuth.photo"
              class="rounded-circle header-profile-user"
              :src="userOAuth.photo"
              alt="Header Avatar"
            />
            <i v-else class="bx bx-user h3 align-middle mr-1"></i>
            <span class="d-none d-xl-inline-block ml-1">{{
              userInfo.fullnameen
            }}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <a href="/logout" class="dropdown-item text-danger">
            <i
              class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"
            ></i>
            {{ $t("navbar.dropdown.henry.list.logout") }}
          </a>
        </b-dropdown>

        <div class="dropdown d-inline-block">
          <button
            type="button"
            class="btn header-item noti-icon right-bar-toggle toggle-right"
            @click="toggleRightSidebar"
          >
            <i class="bx bx-cog bx-spin toggle-right"></i>
          </button>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-scoped"
      title="Select workspace application"
      hide-footer
  
    >
      <template #default="{ ok }" v-if="applicationsDataModal">
        <div class="px-lg-2">
          <div class="row no-gutters">
            <template v-for="(item, index) in applicationsDataModal">
              <div class="col-sm-4" v-bind:key="index">
                <a
                  class="dropdown-icon-item"
                  href="javascript: void(0);"
                  @click="
                    onSetApplicationClick(item);
                    ok();
                  "
                >
                  <div class="row">
                    <div class="col-sm-12">
                      <b-avatar
                        class="avatar-center"
                        variant="primary"
                        :text="item.code"
                      ></b-avatar>
                    </div>
                  </div>
                  <span>{{ item.display_name }}</span>
                </a>
              </div>
            </template>
          </div>
        </div>
      </template>
    </b-modal>
  </header>
</template>

<script>
import i18n from "../i18n";
import { mapGetters, mapActions } from "vuex";
// import simplebar from "simplebar-vue";
import { getUserInfo } from "@/helpers/utils/jwt";
import applicationService from "@/helpers/service/application-provider";
import {
  authComputed,
  applicationComputed,
  applicationMethods,
} from "@/state/helpers";
import { eventBus } from "@/main.js";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  data() {
    return {
      isLoading: true,
      fullPage: true,
      applications: [],
      applicationsDataModal: [],
    };
  },
  components: {  Loading },
  mounted() {
    this.onFilter();
  },
  computed: {
    ...authComputed,
    ...applicationComputed,
    userInfo() {
      if (this.getAccessToken !== null) {
        return getUserInfo(this.getAccessToken);
      } else return {};
    },
    userOAuth() {
      let user = this.$cookies.get(".oauth.usr");
      return user;
    },
  },
  methods: {
    ...applicationMethods,
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
    },
    async onFilter() {
      this.showDataTable = true;
      let params = new URLSearchParams();
      params.append("pageSize", 50);
      params.append("status", "Active");

      let result = await applicationService.getApplicationsAsync(params);
      if (result.status === 200) {
        this.applications = [];
        this.applicationsDataModal = result.data.items;
        var tmp = [];
        result.data.items.forEach((element, index) => {
          //   if (index !== 0 && index % 3 == 0) {
          //     this.applications.push({ items: tmp });
          tmp = [];
          tmp.push(element);
          //   } else {
          //     tmp.push(element);
          //     if (index + 1 === result.data.items.length) {
          this.applications.push({ items: tmp });
          //     }
          //   }
        });
        this.isLoading = false;
      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
      this.ADD_FILTER_APPLICATION(result.data.items);
    },
    onSetApplicationClick(item) {
      this.isLoading = true;
      this.ADD_APPLICATION_SELECTED({
        id: item.id,
        name: item.display_name,
        code: item.code,
      });
      setTimeout(() => {
        this.$router.go();
      }, 500);
    },
  },
};
</script>
